import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from "react";
import { useSaleorClient, useSignIn } from "../..";
export function CredentialsProvider(_ref) {
  var children = _ref.children;
  var saleor = useSaleorClient();

  var _useSignIn = useSignIn(),
      _useSignIn2 = _slicedToArray(_useSignIn, 1),
      signIn = _useSignIn2[0];

  var autoSignIn =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var credentials;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return navigator.credentials.get({
                password: true
              });

            case 2:
              credentials = _context.sent;

              if (!credentials) {
                _context.next = 6;
                break;
              }

              _context.next = 6;
              return signIn({
                email: credentials.id,
                password: credentials.password
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function autoSignIn() {
      return _ref2.apply(this, arguments);
    };
  }();

  React.useEffect(function () {
    if (!saleor.legacyAPIProxy.isLoggedIn() && window.PasswordCredential) {
      autoSignIn();
    }
  }, []);
  return children;
}